<div *ngIf="!showHistory" class="m-3">
    <div class="col-lg-9 content-wrapper" style="width: 100%">
        <p class="h3">
            Job Detail
            <span *ngIf="
          JobScheduleViewModel !== null &&
          JobScheduleViewModel.jobDescription !== ''
        ">
        - {{ JobScheduleViewModel.jobDescription }}</span
      >
    </p>
    <hr />

    <div class="control-section" style="min-height: 582px">
      <div
        class="col-lg-9 content-wrapper"
        style="width: 100%; padding: 6px 0px 0px 6px"
      >
        <div
          class="row"
          *ngIf="isScheduler && JobScheduleViewModel.jobScheduleStatusId != 1"
        >
          <div class="dropdownbutton-section">
            <div id="dropdownbutton-control">
              <div class="row">
                <div class="col-12">
                  <button
                    class="float-end me-2 e-info"
                    ejs-dropdownbutton
                    [items]="items"
                    (select)="select($event)"
                    content="Actions"
                    (beforeItemRender)="addDisabled($event)"
                  ></button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <br />
        <div class="row">
          <div class="col-md-2 cl-sm-12">Company</div>
          <div class="col-md-3 cl-sm-12 text-secondary">
            {{ JobScheduleViewModel.companyName }}
          </div>
          <div class="col-md-2 cl-sm-12">Scheduled Date</div>
          <div class="col-md-4 cl-sm-12 text-secondary">
            {{ JobScheduleViewModel.startDate | date : "MM/dd/yyyy" }}
          </div>
        </div>

        <div class="row">
          <div class="col-md-2 cl-sm-12">Job</div>
          <div class="col-md-3 cl-sm-12 text-secondary">
            {{ JobScheduleViewModel.jobDescription }}
          </div>
          <div class="col-md-2 cl-sm-12">Scheduled By</div>
          <div class="col-md-4 cl-sm-12 text-secondary">
            {{ JobScheduleViewModel.createdBy }}
          </div>
        </div>
        <!-- <div class="row">
          <div class="col-md-2 cl-sm-12">Inspector Called</div>
          <div class="col-md-3 cl-sm-12 text-secondary">{{JobScheduleViewModel.inspectorCalled?'Yes':'No'}}</div>
          <div class="col-md-2 cl-sm-12">Status</div>
          <div class="col-md-4 cl-sm-12 text-secondary">{{JobScheduleViewModel.jobScheduleStatusName}}</div>


        </div>
        <div class="row">
          <div class="col-md-2 cl-sm-12">Inspector Needed</div>
          <div class="col-md-3 cl-sm-12 text-secondary">{{JobScheduleViewModel.inspectorNeeded?'Yes':'No'}}</div>
          <div class="col-md-2 cl-sm-12">Rained Out</div>
          <div class="col-md-4 cl-sm-12 text-secondary">{{JobScheduleViewModel.rainedOut?'Yes':'No'}}</div>
        </div> -->

        <br />
        <div
          class="text-black"
          [innerHTML]="JobScheduleViewModel.reviewHTML | safe : 'html'"
        ></div>
        <br />

        <div
          *ngIf="
            JobScheduleViewModel.notes != null &&
            JobScheduleViewModel.notes != ''
          "
        >
          <hr />
          <p class="h5 heading-text">Notes</p>
          <p class="text-secondary">{{ JobScheduleViewModel.notes }}</p>
        </div>

        <button
          ejs-button
          id="btnClose"
          class="e-info btn-bg float-end mx-1 mt-2"
          (click)="Close()"
        >
          Close
        </button>
      </div>
      <!-- </form> -->
    </div>
  </div>
</div>
<!-- History Page -->
<div class="control-section m-3" *ngIf="showHistory" style="min-height: 582px">
  <div class="col-lg-9 content-wrapper" style="width: 100%">
    <p class="h3">
      Audit History
      <span
        *ngIf="
          JobScheduleViewModel !== null &&
          JobScheduleViewModel.jobDescription !== ''
        "
      >
        - {{ JobScheduleViewModel.jobDescription }}</span
      >
    </p>
    <hr />
    <div class="row">
      <div class="col-xs-12 mt-2">
        <button
          ejs-button
          id="btnGoBack"
          class="e-info btn-bg float-end mx-1 mt-2"
          (click)="GoBack()"
        >
          Go Back
        </button>
      </div>
    </div>
    <div class="row mt-2" style="padding: 10px">
      <ejs-grid
        #historyGrid
        class="px-0"
        [dataSource]="gridDataSource"
        allowTextWrap="true"
        [allowPaging]="true"
        height="365px"
        [pageSettings]="pageSettings"
        [toolbar]="toolbar"
        [allowFiltering]="true"
        [filterSettings]="filterOptions"
        allowSorting="true"
        [sortSettings]="sortOptions"
      >
        <e-columns>
          <e-column
            field="auditHistoryId"
            headerText="AuditHistoryId"
            width="100px"
            style="font-weight: 500"
            [visible]="false"
          >
          </e-column>
          <e-column
            field="createdByName"
            headerText="ACTION TAKEN BY"
            [filter]="filter"
            width="115px"
            style="font-weight: 500"
          >
          </e-column>
          <e-column
            field="actionTypeName"
            headerText="ACTION TYPE"
            [filter]="filter"
            width="110px"
            style="font-weight: 500"
          >
          </e-column>
          <!-- <e-column field='text' headerText='AUDIT TEXT' width='350px' style="font-weight: 500;">
          </e-column> -->

          <e-column
            field="createdDate"
            headerText="ACTION TAKEN ON"
            [filter]="filter"
            width="150px"
            style="font-weight: 500"
          >
            <ng-template #template let-data>
              {{ data.createdDate | date : "MM/dd/yyyy, h:mm:ss a zzzz" }}
            </ng-template>
          </e-column>
        </e-columns>
      </ejs-grid>
    </div>
  </div>
</div>
